module.exports = "https://sanskriti-api.vercel.app/api/v1/"
// module.exports = "http://localhost:5000/api/v1/"
